import { Tokens } from '@search/router/src';
import { SearchRoute, ISearchSeoType } from '../searchRoute';

export class SearchMapRoute extends SearchRoute {
    displayName = 'SearchMapRoute';

    protected patternCommon(p: Tokens<ISearchSeoType>) {
        return `${this.patternHost()}(/${p.region})/nedvizhimost/karta`;
    }

    protected checkKarta() {
        // if (seo.geoSlug1 !== 'karta' && seo.geoSlug2 !== 'karta') throw new SchemaTypeError('geoSlug1 !== karta');
    }
}
